<template>
  <div class="productgodraw" :style="{ opacity: opacity }">
    <div class="imgBox" :style="{ height: fullHeight * 0.87 + 'px' }">
      <img :src="url" alt="" />
    </div>
    <div class="opacityBtn" :style="{ height: fullHeight * 0.13 + 'px' }">
      <div class="text">不透明度</div>
      <div class="slider">
        <barprogress
          v-model="opacity"
          :screenWidth="screenWidth"
          @input="changeProgressAction"
        ></barprogress>
      </div>
      <div class="opacityValue">{{ Number(opacity * 100).toFixed(0) }}%</div>
    </div>
  </div>
</template>
<script>
import barprogress from '../components/progress/opacity.vue'
export default {
  data: () => ({
    url: null,
    fullHeight: document.documentElement.clientHeight,
    screenWidth: document.body.clientWidth,
    // 不透明度
    opacity: 1,

  }),
  components: {
    barprogress
  },
  methods: {
    getOpacity (opacity) {
      console.log(opacity);
    },
    changeProgressAction (value) {
      if (value <= 0.05) {
        value = 0.05
      }
      this.opacity = Number(value).toFixed(2)
    },
  },
  created () {
    this.url = this.$route.query.url
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        that.fullHeight = window.fullHeight
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })()
    }
  },
  watch: {
    fullHeight (val) {
      if (!this.timer) {
        this.fullHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    },
    screenWidth (val) {
      this.screenWidth = val;
    }
  }
}
</script>
<style lang="scss">
.productgodraw {
  width: 100%;
  height: 100%;
  .imgBox {
    width: 100%;
    // height: 1000px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .opacityBtn {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    background: rgba($color: #000000, $alpha: 0.6);
    // border-radius: 10px;
    justify-content: center;
    align-items: center;
    background-color: #000;
    .slider {
      width: 80%;
      margin: 0 15px;
      .el-slider__runway {
        height: 4px;
        position: relative;
      }
      .el-slider__bar {
        background-color: #fd9552;
        height: 4px;
      }
      .el-slider__button-wrapper {
        position: absolute;
        // top: -17px !important;
      }
      .el-slider__button {
        background-color: #fd9552;
        width: 20px;
        height: 20px;
        border: 2px solid #ffffff;
      }
    }
    .text {
      // width: 100px;
      text-align: center;
      font-size: 12px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      color: #ffffff;
      opacity: 1;
    }
    .opacityValue {
      width: 80px;
      text-align: center;
      font-size: 12px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      color: #ffffff;
      opacity: 1;
    }
  }
}
</style>